import React, { Component} from "react";

class ThumbsUp extends Component {
	render() {
		return (
			<div className="container mt-xl-5 pt-5">
				<div className="row justify-content-center">
					<div className="col-6">
						<h2 className="text-center mb-1 font-weight-bold">آیا این مطلب به شما کمک کرد؟</h2>
					</div>
				</div>
				<div className="row justify-content-center">
					<div className="col-lg-3 pr-0 col-md-6 text-center">
						<button className="thumbs-up-button">X</button>
					</div>
					<div className="col-lg-3 pl-0 col-md-6 text-center">
						<button className="thumbs-up-button">tik</button>
					</div>
				</div>
			</div>
		);
	}
}
export default ThumbsUp;